module.exports = __webpack_public_path__ + "media/images/sports_icons/kickball-9ebd39b6ba79e7ca69febcf8b30e4d91.png";